__turbopack_context__.v({
  "warning": "WarningTest-module-scss-module__y6Mv-W__warning",
});
